import { render, staticRenderFns } from "./ModalOTP.vue?vue&type=template&id=12fe6372&scoped=true&"
import script from "./ModalOTP.vue?vue&type=script&lang=js&"
export * from "./ModalOTP.vue?vue&type=script&lang=js&"
import style0 from "./ModalOTP.vue?vue&type=style&index=0&id=12fe6372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe6372",
  null
  
)

export default component.exports